import { useTheme } from "@mui/material/styles";

import { themeMode } from "../../providers/theme/MuiThemeProvider";

const TankLevelMenuIconFilled = (): JSX.Element => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill={theme.palette.primary.main} />
      <path
        d="M9.33301 21V11"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M22.667 11V21"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M15.9997 14.3332C19.6816 14.3332 22.6663 12.8408 22.6663 10.9998C22.6663 9.15889 19.6816 7.6665 15.9997 7.6665C12.3178 7.6665 9.33301 9.15889 9.33301 10.9998C9.33301 12.8408 12.3178 14.3332 15.9997 14.3332Z"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
      />
      <path
        d="M22.6663 16C22.6663 17.8409 19.6816 19.3333 15.9997 19.3333C12.3178 19.3333 9.33301 17.8409 9.33301 16"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
      />
      <path
        d="M22.6663 21C22.6663 22.8409 19.6816 24.3333 15.9997 24.3333C12.3178 24.3333 9.33301 22.8409 9.33301 21"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default TankLevelMenuIconFilled;
